import {FeedbackReducerActionType, useFeedbackDispatch} from "../../utils/FeedbackContext";
import {useEffect, useRef, useState} from "react";
import FetchState from "../../api/FetchState";
import {useHistory, useLocation} from "react-router-dom";
import {getMembersDependants, getMembersNotes} from "../../api/RestCallHelper";

export function useFetchMembersNotes() {

    let location = useLocation();
    let history = useHistory();

    let dispatch = useFeedbackDispatch();
    const [fetchState, setFetchState] = useState(FetchState.LOADING);

    const [isSending, setIsSending] = useState(false);
    const isMounted = useRef(true);

    const [notes, setNotes] = useState();

    const close = (event, reason) => {
        console.log("In MemberFormNotesTable close callback");
        if (reason === 'clickaway') return;

        dispatch({type: FeedbackReducerActionType.CLOSE_FEEDBACK});
    };

    useEffect(() => {

        // don't send again while we are sending
        if (isSending) return;

        // update state
        setIsSending(true);

        // send the actual request
        if (location.state.edit) {
            getMembersNotes(location.state.member.id, setNotes, dispatch, setFetchState, close, history, location);
        }

        // once the request is sent, update state again
        if (isMounted.current)
            // only update if we are still mounted
            setIsSending(false);

    }, [setNotes, setIsSending]);

    return [notes, fetchState];

}

export function useFetchMembersDependants() {

    let location = useLocation();
    let history = useHistory();

    const [dependants, setDependants] = useState();

    let dispatch = useFeedbackDispatch();
    const [fetchState, setFetchState] = useState(FetchState.LOADING);

    const [isSending, setIsSending] = useState(false);
    const isMounted = useRef(true);

    const close = (event, reason) => {
        console.log("In MemberFormDependantTable close callback");
        if (reason === 'clickaway') return;

        dispatch({type: FeedbackReducerActionType.CLOSE_FEEDBACK});
    };

    useEffect(() => {

        // don't send again while we are sending
        if (isSending) return;

        // update state
        setIsSending(true);

        // send the actual request
        if (location.state.edit) {
            getMembersDependants(location.state.member.id, setDependants, dispatch, setFetchState, close, history, location);
        }

        // once the request is sent, update state again
        if (isMounted.current)
            // only update if we are still mounted
            setIsSending(false);

    }, [setDependants, setIsSending]);

    return [dependants, fetchState];

}